import { useQueryWithCallbacks } from '../../hooks/useQueryWithCallbacks';
import { QueryKeys } from '../queryKeys';

interface IVersionInfo {
  version: string;
}

const getVersionInfo = async (): Promise<IVersionInfo> => {
  // Add query to prevent CDN caching
  const resp = await fetch(`/version.json?now=${Date.now()}`);
  const data = await resp.text();

  try {
    return JSON.parse(data);
  } catch {
    // Since we render a frontend 404 as HTML, this is the way to catch it
    //
    // If this happens, assume we are in the latest version
    return { version: (import.meta.env.VITE_APP_VERSION as string | undefined) ?? '' };
  }
};

export const usePollVersionInfo = () => {
  return useQueryWithCallbacks({
    queryKey: [QueryKeys.getVersionInfo],
    queryFn: getVersionInfo,
    refetchInterval: 30_000,
  });
};
